import React, { useEffect, useState } from 'react'
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { getEmailTemplates } from '../../../actions/emailTemplateAction';
import CAlert from '../../../components/sharedComponents/CAlert';
import EmailEditor from '../../../components/Email/EmailEditor';
import EmailLayout from '../../../components/Email/EmailLayout';
import ListViewModal from '../ListViewModal';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../emails.css'
import { getUsers } from '../../../actions/usersActions';
import { onUploadXLSX, validateEmail, renderIncludedOrNot } from './sendEmailFuncs';
import { sendEmails } from '../../../actions/emailActions';
import { emailSentEmailsLink } from '../../../routeLinks';
import { Redirect } from 'react-router-dom'

const FROM_DATABASE = 'database'
const FROM_EXCEL = 'excel'

const SendEmail = props => {
    const { userDetails } = props

    const [templateList, setTemplateList] = useState([])
    const [userList, setUserList] = useState([])
    const [excelEmailList, setExcelEmailList] = useState([])
    const [sent_to, setSent_to] = useState([])
    const [selectedTemplateObj, setSelectedTemplateObj] = useState(null)
    const [emailIsSent, setEmailIsSent] = useState(false)
    const [resObj, setResObj] = useState()
    const [isLoading, setIsloading] = useState(false)
    const [errorText, setErrorText] = useState(null)
    const [typeEmail, setTypeEmail] = useState('')
    const [addRecipientsBy, setAddRecipientsBy] = useState('')
    const [confirmModal, setConfirmModal] = useState(false)
    const [redirectTo, setRedirectTo] = useState(null)

    useEffect(() => {
        setIsloading(true)

        const fetchData = async () => {
            await getEmailTemplates(setTemplateList, renderError)
            await getUsers(setUserList, renderError)
        }
        fetchData();

        setIsloading(false)
    }, [])

    useEffect(() => {
        if (!emailIsSent) return
        onEmailSent()
    }, [emailIsSent])

    function renderError(err) {
        setErrorText(err)
        isLoading && setIsloading(false)
        return
    }

    function onEmailSent() {
        setSelectedTemplateObj(null)
        setTemplateList([])
        setSent_to([])
    }

    const ableToSent = selectedTemplateObj !== null && sent_to.length !== 0


    async function addEmailToSentTo(email = null, emailList = []) {

        if (!emailList.length) {
            const cEmail = email || typeEmail

            if (!validateEmail(cEmail)) return
            const newList = [...sent_to, cEmail]
            // remove duplicated email
            setSent_to([...new Set(newList)])
        } else {
            const validatedEmailList = emailList.map(e => validateEmail(e) && e)
            const newList = sent_to.concat(validatedEmailList);
            // remove duplicated email
            setSent_to([...new Set(newList)])
        }

        !email && setTypeEmail('')
    }
    function removeEmailFromSentTo(email, emailList = []) {

        const newList = emailList.length ?
            sent_to.filter(e => !emailList.includes(e))
            : sent_to.filter(e => e !== email)

        setSent_to(newList)
    }

    async function handleOnSentEmail() {
        // Maybe move all this logic to the backend might be better. And then we can await the promise there to store everything
        if (!userDetails || !ableToSent) return
        setIsloading(true)

        const reqBody = {
            user_id: userDetails.user._id,
            email_template_id: selectedTemplateObj._id,
            sent_to
        }

        await sendEmails(reqBody, (res) => {
            console.log('res', res)
            setEmailIsSent(true)
            setIsloading(false)
        }, renderError)

        // const emailURI = 'https://script.google.com/macros/s/AKfycbx5GA48Ha0aGxkJI8z-O6IKiAXGu9vo_WmNiS9je0H_OK9z61Y8sPvmibmClqUagI1ipw/exec'
        // const reqBody = {
        //     htmlBody: selectedTemplateObj.content,
        //     subject: selectedTemplateObj.subject,
        //     key: "nnnlwe19219n1b2--u0qjasca",
        // }

        // Promise.all(userRequests).then(e => {

        // const accepted = []
        // const rejected = []
        //     const userRequests = []

        // // change to for loop
        // sent_to.forEach(email => {
        //     const object = JSON.stringify({ ...reqBody, email })
        //     const result = axios.post(emailURI, object)
        //         .then(({ data }) => accepted.push(email))
        //         .catch(err => rejected.push(email))
        //     userRequests.push(result)
        // })

        // Promise.all(userRequests).then(e => {
        //     setResObj({
        //         sent_to,
        //         accepted: accepted,
        //         rejected: rejected,
        //     })
        //     // add logic to save response details
        //     setEmailIsSent(true)
        //     setIsloading(false)
        // })
        //     .catch(err => {
        //         renderError(err)
        //         setIsloading(false)
        //     })

    }

    if (redirectTo && redirectTo !== '') {
        return <Redirect to={redirectTo} />
    }

    return <EmailLayout title='Send Email' isLoading={isLoading}>
        <CAlert show={errorText !== null} text={errorText} color='danger' />
        <CAlert show={emailIsSent} color='success'
            text={`Send email has been requested!\n
            Click me to check the status.
            `}
            onClick={() => setRedirectTo(emailSentEmailsLink)}
            timeout />
        {/* <ListViewModal
            modalTitle='Respond Recipients'
            triggerButtonComponent={
                <CAlert show={emailIsSent} color='success'
                    text={'Send email has been requested!'}
                    timeout />
            }
            childrenComponent={resObj?.sent_to.map((m, mIndex) => <li key={mIndex + 'resObj'}>{m} {renderIncludedOrNot(m, resObj?.accepted)}</li>)}
        /> */}
        <FormGroup>
            <Label for="exampleSelect">Select Template</Label>
            <Input type="select" name="email-template"
                onChange={e => {
                    resObj && setResObj(null)

                    const selectedTemp = templateList.find(temp => temp._id === e.target.value)
                    if (!selectedTemp) return
                    setSelectedTemplateObj(selectedTemp)
                }}>
                <option value=''>Select</option>
                {templateList
                    .map((t, tIndex) => <option key={tIndex + 'templateList'} value={t._id}>{t.name}</option>)
                }
            </Input>
        </FormGroup>

        <FormGroup>
            <Label for="exampleSelect">Add Recipients From:</Label>
            <Row>
                <Col >
                    <Input type="select" onChange={e => setAddRecipientsBy(e.target.value)}>
                        <option value=''>Select</option>
                        <option value={FROM_DATABASE}>From Database</option>
                        <option value={FROM_EXCEL}>From Excel File</option>
                    </Input>
                </Col>
                {addRecipientsBy === FROM_DATABASE &&
                    <Col xs="auto">
                        <ListViewModal
                            modalTitle="Select User's Email"
                            triggerButtonComponent={
                                <Button color={ableToSent ? 'info' : 'secondary'} disabled={!userList.length}
                                >Select Emails</Button>
                            }
                            childrenComponent={userList?.map((usr, uIndex) =>
                                <li key={uIndex + 'userList'}
                                    style={{ cursor: 'pointer', }}
                                    onClick={() => {
                                        sent_to.includes(usr.email)
                                            ? removeEmailFromSentTo(usr.email)
                                            : addEmailToSentTo(usr.email)
                                    }}>
                                    <i style={{ opacity: '0.5' }}>{usr.email} </i>{renderIncludedOrNot(usr.email, sent_to)}
                                </li>)}
                            footerComponent={<>
                                <Button
                                    onClick={() => {
                                        const emailList = userList.map(usr => usr.email)
                                        addEmailToSentTo(null, emailList)
                                    }}>Select All</Button>
                                <Button
                                    onClick={() => {
                                        const emailList = userList.map(usr => usr.email)
                                        removeEmailFromSentTo(null, emailList)
                                    }}>Unselect All</Button>
                            </>}
                        />
                    </Col>}
            </Row>
        </FormGroup>

        {addRecipientsBy === FROM_EXCEL &&
            <>
                <input type="file" onChange={async (e) => {
                    setIsloading(true)
                    const parsed = await onUploadXLSX(e, 'sheet_to_csv')
                    // split parsed string and validate emails
                    const validatedEmails = parsed.split('\n')?.filter(e => validateEmail(e))
                    // set only unique email
                    setExcelEmailList([...new Set(validatedEmails)])
                    setIsloading(false)
                }} />

                <ListViewModal
                    modalTitle='Select Email'
                    triggerButtonComponent={
                        <Button color={ableToSent ? 'info' : 'secondary'} disabled={!excelEmailList.length}
                        >Select Emails</Button>
                    }
                    childrenComponent={excelEmailList?.map((m, mIndex) =>
                        <li key={mIndex + 'excelList'}
                            style={{ cursor: 'pointer', }}
                            onClick={() => {
                                sent_to.includes(m)
                                    ? removeEmailFromSentTo(m)
                                    : addEmailToSentTo(m)
                            }}>
                            <i style={{ opacity: '0.5' }}>{m} </i>{renderIncludedOrNot(m, sent_to)}
                        </li>)}
                    footerComponent={<>
                        <Button
                            onClick={() => {
                                addEmailToSentTo(null, excelEmailList)
                            }}>Select All</Button>
                        <Button
                            onClick={() => {
                                removeEmailFromSentTo(null, excelEmailList)
                            }}>Unselect All</Button>
                    </>}
                />
                <br />
                <br />
            </>
        }
        <div>
            <Label>Recipients: <strong>{sent_to.length}</strong>
                {sent_to.length ? <span style={{
                    fontSize: '0.75rem',
                    margin: '0px 4px',
                    padding: '3px 4px 3.5px',
                    width: 'fit-content',
                    backgroundColor: '#ff000024',
                    color: '#dc35459c',
                    borderRadius: '5px',
                    cursor: 'pointer'
                }} onClick={() => {
                    if (window.confirm('Clear all recipients?')) setSent_to([])
                }}><FontAwesomeIcon icon={faTrash} /></span> : null}
            </Label>
            <ul className='recipients-container'>
                {React.Children.toArray(
                    sent_to
                        .map((t, tIndex) => <li key={tIndex + 'excelSentTo'} className='added'>{t}
                            <span className="remove" onClick={() => removeEmailFromSentTo(t)}>x</span>
                        </li>)
                )}

                <li className='add' >
                    <input style={{
                        backgroundColor: typeEmail !== '' ?
                            validateEmail(typeEmail) ? '#00800024' : '#ff000024' : 'initial'
                    }}
                        type='email' placeholder='enter email' value={typeEmail} onChange={(e) => setTypeEmail(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' ? addEmailToSentTo() : null}
                    />
                    <span onClick={() => addEmailToSentTo()}>+</span>

                </li>
            </ul>
        </div>

        {selectedTemplateObj !== null ? <>
            <div>Subject: {selectedTemplateObj?.subject}</div>
            <EmailEditor
                disabled={true} initialValue={selectedTemplateObj?.content} />
        </> : null}

        <br />
        <ListViewModal
            render={confirmModal}
            modalTitle='Confirm Sent To:'
            triggerButtonComponent={
                <center>
                    <Button onClick={() => setConfirmModal(true)}
                        color={ableToSent ? 'info' : 'secondary'} disabled={!ableToSent}
                    >Sent Emails</Button>
                </center>
            }
            childrenComponent={sent_to.map((m, mIndex) => <li key={mIndex + 'sentList'}>{m}</li>)}
            footerComponent={<Button color={ableToSent ? 'info' : 'secondary'} disabled={!ableToSent}
                onClick={() => {
                    setConfirmModal(false)
                    handleOnSentEmail()
                }}>Confirm Send</Button>}
        />
    </EmailLayout >
}


export default SendEmail;